import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/booking-engine-page/booking-engine-page/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/booking-engine-page/booking-engine-page/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/booking-engine-page/booking-engine-page/src/_pages/PropertyPage/PropertyPage.js");
